import { TFunction } from 'i18next';

export const getErrorMessage = (t: TFunction, error: unknown): string => {
  // Type guard to check if error is an object with the expected properties
  const errorObj = error as { errorCode?: string; error?: string };
  
  // If the error has an errorCode, try to translate it
  if (errorObj.errorCode) {
    const translationKey = `errors.${errorObj.errorCode}`;
    const translation = t(translationKey);
    
    // If translation exists and is different from the key, use it
    if (translation !== translationKey) {
      return translation;
    }
  }
  
  // Fallback to error message if provided
  if (errorObj.error) {
    return errorObj.error;
  }
  
  // Fallback to generic error message
  return t('errors.generic');
};